import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from 'react';

import { cx } from './internal/cx.js';

/** Semantic icon button tones. */
export type IconButtonTone = 'neutral' | 'danger';

const TONE_CLASS: Record<IconButtonTone, string> = {
  neutral: 'nrx-icon-btn--neutral',
  danger: 'nrx-icon-btn--danger',
};

export type IconButtonProps = ComponentPropsWithoutRef<'button'> & {
  children: ReactNode;
  /** Accessible label — required because icon buttons have no visible text. */
  'aria-label': string;
  tone?: IconButtonTone;
};

/** Compact icon-only button for toolbars and panel controls. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { children, className, tone = 'neutral', type = 'button', ...props },
  ref,
): React.JSX.Element {
  return (
    <button
      ref={ref}
      type={type}
      className={cx('nrx-icon-btn', TONE_CLASS[tone], className)}
      {...props}
    >
      {children}
    </button>
  );
});
